module.exports = __webpack_public_path__ + "img/favicon.b6e8bade.png";